import { create } from 'zustand';

export const useSearchTextBox = create((set) => ({
  search: '',
  setSearch: (value: string) => set(() => ({ search: value }))
}));

export const useRowsAgGrid = create((set) => ({
  rowsAgGrid: [],
  setRowsAgGrid: (data: any) => set(() => ({ rowsAgGrid: data }))
}));

export const useRowsStarredAgGrid = create((set) => ({
  rowsAgGrid: [],
  setRowsAgGrid: (data: any) => set(() => ({ rowsAgGrid: data }))
}));

export const usePoppoverDisplay = create((set) => ({
  openPopover: false,
  setOpenPopover: (open: boolean) => set(() => ({ openPopover: open }))
}));

export const useisDeleteViewSelected = create((set) => ({
  delete: false,
  setDelete: (isDeleted: boolean) => set(() => ({ delete: isDeleted }))
}));

export const useisSharedViewSelected = create((set) => ({
  share: null,
  setShare: (data: any) => set(() => ({ share: data }))
}));

export const useOpenModal = create((set) => ({
  openModal: false,
  setOpenModal: (open: boolean) => set(() => ({ openModal: open }))
}));

export const useCollectionAlreadyExists = create((set) => ({
  collectionRepeteaded: false,
  setCollectionRepeteaded: (repeteaded: boolean) =>
    set(() => ({ collectionRepeteaded: repeteaded }))
}));

export const useRepeteadedCollection = create((set) => ({
  repeteaded: false,
  setRepeteaded: (open: boolean) => set(() => ({ repeteaded: open }))
}));

export const useColletionsSelected = create((set) => ({
  collections: [],
  setCollections: (data: any) => set(() => ({ collections: data }))
}));

export const useGoingToFromMyViews = create((set) => ({
  going: null,
  setGoing: (go: any) => set(() => ({ going: go }))
}));

export const useStoreCollectionToUpdate = create((set) => ({
  collection: null,
  setCollection: (data: any) => set(() => ({ collection: data }))
}));

export const useShowFileUpdated = create((set) => ({
  show: false,
  setShow: (open: boolean) => set(() => ({ show: open }))
}));

export const useShowFileUpdatedGranted = create((set) => ({
  show: false,
  setShow: (open: boolean) => set(() => ({ show: open }))
}));

export const useStoreCollectionPreSelected = create((set) => ({
  data: null,
  setData: (data: any) => set(() => ({ data: data }))
}));

export const useLastMenuData = create((set) => ({
  data: null,
  setData: (data: any) => set(() => ({ data: data }))
}));

export const useStarredView = create((set) => ({
  starred: null,
  setStarred: (click: any) => set(() => ({ starred: click }))
}));

export const useTabsClicked = create((set) => ({
  isClicked: false,
  setIsClicked: (open: boolean) => set(() => ({ isClicked: open }))
}));

type CollectionsAndItemsStore = {
  collection: any;
  items: any[];
  setCollection: (collection: any) => void;
  setItems: (items: any) => void;
};

export const useCollectionsAndItems = create<CollectionsAndItemsStore>((set) => ({
  collection: null,
  items: [],
  setCollection: (collection: any) => set(() => ({ collection })),
  setItems: (items: any) => set(() => ({ items }))
}));
